import { OpenInNewOutlined } from '@mui/icons-material';
import React from 'react';
import Spacer from './Spacer';

function PreviewGoogleDrivePdf({fileId}) {
    return (
        <>
            <div style={{ textAlign: 'center' }}>
                <embed
                    src={`https://drive.google.com/file/d/${fileId}/preview`}
                    type="application/pdf"
                    width="90%"
                    height="600px"
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                <a
                    href={`https://drive.google.com/file/d/${fileId}/view`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'none',
                        color: 'var(--common-main-light-color)',
                        fontSize: '85%',
                        marginTop: '10px',
                        display: 'block',
                        textAlign: 'center'
                    }}
                >
                    Googleドライブで開く
                </a>
                <Spacer width={3} />
                <OpenInNewOutlined style={{
                    color: 'var(--common-main-light-color)',
                    fontSize: '18px',
                }} />
            </div>
        </>
    );
}

export default PreviewGoogleDrivePdf;